/* The short gold rule under a heading, drawing itself on when it scrolls into view — the same gesture as
   the logo's starburst drawing on in the homepage hero.

   Usage: <GoldRule className="bl-rule" /> in place of <div className="bl-rule" />. The page's own class
   keeps its width, height, color and margins; this only adds the draw-on. `align="center"` for a rule that
   is centered under its heading. Visitors who ask for reduced motion see the rule already drawn. */

import React, { useEffect, useRef, useState } from "react";
import "./GoldRule.css";

export default function GoldRule({ className = "", align = "left", ...rest }) {
  const ref = useRef(null);
  // Off on the server and in the browser alike, so a saved page is taken over without a mismatch.
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!("IntersectionObserver" in window) || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) { setOn(true); return; }
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setOn(true); o.unobserve(el); } }, { threshold: 0.5 });
    o.observe(el);
    return () => o.disconnect();
  }, []);
  return <div ref={ref} aria-hidden="true" className={`gold-rule gold-rule-${align} ${on ? "is-on" : ""} ${className}`.trim()} {...rest} />;
}
